export function createRejectedPrepare() {
  return error => ({
    payload: null,
    error
  });
}